// Temp recreating the cssModules function from Backpack to aid with removal of Backpack
// The aim will be to setup CSS modules properly as we have done in other libraries and remove this function.

export default ((styles = {}) => (...classNames) => classNames.reduce((className, currentClass) => {
  if (currentClass && typeof currentClass === 'string') {
    const realName = styles[currentClass] || currentClass;
    return className ? `${className} ${realName}` : realName;
  }
  return className;
}, ''));